import Currency from "./Currency";

interface MetricCardProps {
  label: string;
  value: number;
  valueClassName?: string;
}

export default function MetricCard({
  label,
  value,
  valueClassName,
}: MetricCardProps) {
  return (
    <div>
      <div className="text-xs uppercase tracking-widest text-primary-600 dark:text-primary-400 mb-2">
        {label}
      </div>
      <div
        className={`text-2xl font-light ${valueClassName || "text-primary-950 dark:text-white"}`}
      >
        <Currency value={value} />
      </div>
    </div>
  );
}
